/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Option_ClearInputs */

const en_us2_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete all and start from scratch`)
};

const pt_br2_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar todos e montar do zero`)
};

const es_419_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todo y empezar de cero`)
};

const pt_pt2_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar todos e começar do zero`)
};

const fr_fr2_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout supprimer et repartir de zéro`)
};

const de_de2_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles löschen und neu anfangen`)
};

const it_it2_plan_build_option_clear = /** @type {(inputs: Plan_Build_Option_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina tutto e riparti da zero`)
};

/**
* | output |
* | --- |
* | "Delete all and start from scratch" |
*
* @param {Plan_Build_Option_ClearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_option_clear = /** @type {((inputs?: Plan_Build_Option_ClearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Option_ClearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_option_clear(inputs)
	if (locale === "es-419") return es_419_plan_build_option_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_option_clear(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_option_clear(inputs)
	if (locale === "de-DE") return de_de2_plan_build_option_clear(inputs)
	if (locale === "it-IT") return it_it2_plan_build_option_clear(inputs)
	return en_us2_plan_build_option_clear(inputs)
});
export { plan_build_option_clear as "plan-build.option_clear" }